// Kept outside of the generic `Registry` map on purpose: `Registry.clear()` is called between tests to reset runtime
// values (access token, organization id, ...), and it must not unregister the platform client the application (or
// the test setup) registered once when it loaded.
var registeredPlatforms;
/**
 * Registers the platform clients the foundation packages use to call the Coveo Platform.
 * The application must call it once when it loads, before any foundation code calls `getPlatform()`.
 * Calling it again replaces the previously registered clients.
 *
 * @param options The clients to register.
 */ export var registerPlatform = function registerPlatform(param) {
    var platform = param.platform, platformNoHandlers = param.platformNoHandlers;
    registeredPlatforms = {
        platform: platform,
        platformNoHandlers: platformNoHandlers
    };
};
/**
 * Retrieves the platform client registered by the application with `registerPlatform()`.
 * Call it when you need the client (e.g. in a query function), never at module load time.
 *
 * @param options An optional object to customize the returned client.
 * - `handlers` If false, returns the client without response handlers. Defaults to `true`.
 * @returns The registered platform client.
 * @throws An error if no platform client was registered.
 */ export var getPlatform = function getPlatform(options) {
    if (!registeredPlatforms) {
        throw new Error('No platform client is registered. The application must call `registerPlatform({platform, platformNoHandlers})` from "@core/registry" before using the foundation packages.');
    }
    return (options === null || options === void 0 ? void 0 : options.handlers) === false ? registeredPlatforms.platformNoHandlers : registeredPlatforms.platform;
};

//# sourceMappingURL=PlatformRegistry.js.map